import { Reveal } from "@/components/Reveal";
import { Logo } from "@/components/Logo";

export const PageHeader = ({ eyebrow, title, description }) => (
    <section className="relative overflow-hidden bg-navy pt-40 pb-20 sm:pb-24">
        <Logo className="pointer-events-none absolute -right-16 -top-16 h-96 w-96 opacity-[0.06] animate-slow-spin" />
        <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <p className="eyebrow">{eyebrow}</p>
                <h1 className="mt-4 font-serif text-4xl font-semibold tracking-tight text-ivory sm:text-5xl">{title}</h1>
                <div className="gold-rule mt-6" />
                {description ? <p className="mt-6 max-w-2xl text-base leading-relaxed text-ivory/70">{description}</p> : null}
            </Reveal>
        </div>
    </section>
);
